import {h, Fragment} from "preact"
export default function Checkbox({ valueName, value, selected, onChange, className, id }) {
    return (
        <label htmlFor={id} className={`ns-filter-label ns-flex ns-flex-nowrap ns-items-center ${className || ''}`}>
            <input type="checkbox" value={value} checked={selected} onChange={onChange} id={id} />
            <span>{valueName}</span>
        </label>
    )
}